import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propBool, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import InputError from '../../../../../../Ui/Common/InputError';
import PlainInput from '../../../../../../Ui/Common/PlainInput';
/**
 * セミナーのプライバシーポリシーURL入力コンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormPrivacyPolicyUrlField = (props) => {
    const { className, disabled, input, meta } = props;
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_privacy_policy_url' }, { children: [_jsx("div", Object.assign({ className: 'privacy_policy_url_title' }, { children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FCURL" })), _jsxs("div", Object.assign({ className: 'privacy_policy_url_inner field' }, { children: [_jsx(PlainInput, { className: 'privacy_policy_url_input', disabled: disabled, input: input, meta: meta }), _jsx(InputError, { meta: meta })] }))] })) })));
};
SeminarOneFormPrivacyPolicyUrlField.propTypes = {
    className: propStr(),
    disabled: propBool(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
SeminarOneFormPrivacyPolicyUrlField.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormPrivacyPolicyUrlField;
